// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "565535a";
